import React from "react";
import firebase from "../../../lib/firebase";
import sanitizeHtml from "sanitize-html";
import prettyDate from "pretty-date";
import FlatButton from "material-ui/FlatButton";
import DeleteIcon from "material-ui/svg-icons/action/delete";
// import EmailIcon from "material-ui/svg-icons/communication/email";
import NoticeWriteDialog from "./NoticeWriteDialog";
import NoticeModifyDialog from "./NoticeModifyDialog";
import "./NoticeList.css";

export default class NoticeList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            liveData: [],
            isAdmin: false,
            notice_email_send_status: 0,
            notice_email_send_total: 0,
            notice_email_send_complete: 0
        };
    }

    componentDidMount() {
        this.startLive();
        if (!firebase.auth().currentUser)
            return false;
        firebase.database().ref(`campaign/${this.props.campaignId}/info`).once('value').then(function (sp) {
            if (firebase.auth().currentUser.uid === sp.val().userKey)
                this.setState({isAdmin: true});
        }.bind(this));
    }

    componentWillUnmount() {
        this.stopLive();
    }

    startLive() {
        this.f_value_ref = firebase.database().ref(`campaign/${this.props.campaignId}/notices`).limitToLast(100).on('value', function (sp) {
            var data = [];
            sp.forEach(function (e) {
                data.push(Object.assign({}, e.val(), {key: e.key}));
            });
            data.sort(function (o1, o2) {
                return o2.updated - o1.updated;
            });
            this.setState({
                liveData: data
            });
        }.bind(this));
    }

    stopLive() {
        if (this.f_value_ref) {
            firebase.database().ref(`campaign/${this.props.campaignId}/notices`).off('child_added', this.f_value_ref);
        }
    }

    generateControl(e) {
        /* todo 이메일 기능을 현재는 제공하지 않기 때문에 비활성화 함
        var emailBtn;
        if (e.notice_email_send_status === 1) {
            emailBtn = (
                <FlatButton
                    label="이메일 발송 완료"
                    icon={<EmailIcon />}
                    disabled={true}
                />
            );
        } else {
            emailBtn = (
                <FlatButton
                    label="이메일 발송"
                    icon={<EmailIcon />}
                    onClick={function (id) {
                        if (window.confirm("정말 발송합니까?")) {
                            if (id) {
                                firebase.database().ref(`campaign/${this.props.campaignId}/notices/${id}`).update({
                                    'notice_email_send_status': 1
                                });
                            }
                        }
                    }.bind(this, e.key)}
                />
            );
        }
        */
        let status = (e.notice_email_send_status === 1 ) ? <div
            className="emailStatus">{`발송 이메일 : 전체 ${e.notice_email_send_total} 중, 대기 : ${e.notice_email_send_pending}, 완료 : ${e.notice_email_send_complete}`}</div> : '';
        return (
            <div className="control">
                <ul>
                    <li>
                        <NoticeModifyDialog
                            title={e.title}
                            msg={e.msg}
                            isPublic={Number(e.isPublic)}
                            noticeKey={e.key}
                            campaignId={this.props.campaignId}
                            onSubmit={function (data) {
                                firebase.database().ref(`campaign/${this.props.campaignId}/notices/${data.noticeKey}`).update(data);
                            }.bind(this)}
                        />
                    </li>
                    <li>
                        <FlatButton
                            label="삭제"
                            icon={<DeleteIcon />}
                            onClick={function (id) {
                                if (window.confirm("정말 삭제합니까?")) {
                                    if (id) {
                                        firebase.database().ref(`campaign/${this.props.campaignId}/notices/${id}`).remove();
                                    }
                                }
                            }.bind(this, e.key)}
                        />
                    </li>
                    <li>
                        {/*{emailBtn}*/}
                    </li>
                </ul>
                {status}
            </div>
        );
    }

    render() {
        let uid = firebase.auth().currentUser ? firebase.auth().currentUser.uid : false;
        let writeDialog = (this.state.isAdmin) ? (
            <NoticeWriteDialog campaignId={this.props.campaignId} onSubmit={function (data) {
                firebase.database().ref(`campaign/${this.props.campaignId}/notices`).push(data);
            }.bind(this)}/>
        ) : <span />;
        let list = this.state.liveData.map(function (e, i) {
            let control = (uid && e.userKey === uid) ? this.generateControl(e) : "";
            return (
                <li
                    key={e.key}
                >
                    <h1 dangerouslySetInnerHTML={{__html: sanitizeHtml(e.title)}}/>
                    <div className="info">{e.displayName} | {prettyDate.format(new Date(e.updated))}</div>
                    <div className="msg" dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(e.msg, {
                            allowedTags: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
                                'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div',
                                'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre'],
                            allowedAttributes: {
                                a: ['href', 'name', 'target'],
                                // We don't currently allow img itself by default, but this
                                // would make sense if we did
                                img: ['src']
                            },
// Lots of these won't come up by default because we don't allow them
                            selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
// URL schemes we permit
                            allowedSchemes: ['http', 'https', 'ftp', 'mailto'],
                            allowedSchemesByTag: {},
                            allowProtocolRelative: true
                        })
                    }}/>
                    {control}
                </li>
            );
        }.bind(this));
        return (
            <div className="NoticeList">
                {writeDialog}
                <ul className="list">{list}</ul>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/container/campaign/component/NoticeList.js